import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import TableSorting from 'components/TableSorting';
import Search from 'components/Search';
import FlightList, { makeFilter } from 'components/FlightList';

import { makeAfter, withData } from 'lib';
import { FlightListPageQuery } from '__generated__/FlightListPageQuery.graphql';
import EntityListPageSkeleton from 'components/OrderListPageSkeleton';

const query = graphql`
  query FlightListPageQuery(
    $first: Int!
    $after: String
    $filters: FlightFilters
    $search: String
    $sort: FlightSorting
  ) {
    ...FlightList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<FlightListPageQuery>;
};

const breadcrumbs = [{ name: 'Skrydžiai' }];

const FlightListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<FlightListPageQuery>(query, preloadedQuery);

  return (
    <Page breadcrumbs={breadcrumbs}>
      <Search>
        <TableSorting>
          <Pagination>
            <FlightList data={data} />
          </Pagination>
        </TableSorting>
      </Search>
    </Page>
  );
};

export default withData<FlightListPageQuery>({
  query,
  reloadOnRender: false,
  loading: <EntityListPageSkeleton breadcrumbs={breadcrumbs} cols={7} />,

  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    filters: makeFilter(searchParams),
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(FlightListPage);
